import {
  RESET_USER,
} from "../actionTypes";

export default function resetUser() {
  return {
    type: RESET_USER,
  };
}
